import { companyStatusOptions } from '@/constants/status';

const headers = [
  { title: 'Logo', key: 'logo_url', sortable: false, width: 140 },
  { title: 'Kode', key: 'code', sortable: true },
  { title: 'Nama', key: 'name', sortable: true },
  { title: 'Email', key: 'email', sortable: true },
  { title: 'Alamat', key: 'address', sortable: true },
  {
    title: 'Status',
    key: 'status',
    sortable: true,
    align: 'center',
  },
  { title: 'Created At', key: 'created_at', sortable: true },
  { title: 'Updated At', key: 'updated_at', sortable: true },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
];

const filters = [
  { title: 'Kode', key: 'code', type: 'text' },
  { title: 'Nama', key: 'name', type: 'text' },
  { title: 'Email', key: 'email', type: 'text' },
  { title: 'Alamat', key: 'address', type: 'text' },
  {
    title: 'Status',
    key: 'status',
    type: 'select',
    selectOptions: companyStatusOptions.map(({ value, title }) => ({ value, title })),
  },
];

export { filters, headers };
